module.exports = __webpack_public_path__ + "static/media/24.7bc4f216.JPG";